<!-- 使用方法同 element button 封装为了处理点击不失焦问题 -->
<template>
  <el-button ref="elementBtn" v-bind="$attrs" @click="clickFn">
    <slot></slot>
  </el-button>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
const elementBtn = ref(null as any);

const emit = defineEmits(['click']);

function clickFn() {
  elementBtn.value?.ref?.blur();
  emit('click');
}
</script>
